import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/categoria-de-puesto';

/**
 * GET Categorias de Puestos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCategoriasDePuestos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Categoria de Puesto
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCategoriaDePuesto = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Categoria de Puesto
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCategoriaDePuesto = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Categoria de Puesto
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCategoriaDePuesto = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Categoria de Puesto
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCategoriaDePuesto = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
